import React from "react";
import IProduct from "../interfaces/IProduct";
import IProductPlayType from "../interfaces/IProductPlayType";

export default (props: {
    entity: IProduct | IProductPlayType;
}): JSX.Element => {
    const { entity } = props;
    const { settings } = entity;
    const clientSettings = settings ? settings.clientSettings : undefined;
    const thumbnail = clientSettings ? clientSettings.thumbnail : undefined;

    if (thumbnail) {
        return (
            <div className="thumbnail thumbnail-with-image">
                <img src={ thumbnail } alt={ entity.name } />
            </div>
        );
    }

    return (
        <div className="thumbnail thumbnail-without-image">
            <label>{ entity.name }</label>
        </div>
    );
};



// WEBPACK FOOTER //
// ./src/components/Thumbnail.tsx